export const USER_API_URL = {
  getUserInfo: () => `/v1/user/info`,
  getUserInfoMe: () => `/v1/users/me`,
  updateUserInfo: (email: string) => `/v1/users/${email}`,
  deleteUserAccount: () => '/v1/user/delete_account',
  changePassword: () => '/v1/user/change_password',
};
